import React from "react";
import slippage from "../../img/trade-interface/slippage.svg";
import { ReactComponent as InfoIcon } from "../../img/trade-interface/info.svg";
import { GlobalStore } from "../../store/global/GlobalStore";
import { Tooltip } from "components/general/Tooltip";

export const SlippageRow: React.FC = () => {
  const theme = GlobalStore.useState(s => s.theme);
  const slippageText =
    "Difference between the price you see and the price that you get. You will not encounter slippage on Bebop.";

  return (
    <>
      <hr className="dashed my-1" />
      <div className="d-flex justify-content-between align-items-center" data-testid="slippage-row">
        <div className="d-flex align-items-center text-secondary">
          <div className={`d-flex`} style={{ color: theme.font.secondary.default }}>
            <img src={slippage} className="me-2" alt={"Slippage"} style={{ padding: "2px" }} />
            <div className="d-flex align-items-center">
              Slippage
              <Tooltip placement="right" title={slippageText}>
                <InfoIcon className="ms-2 d-none d-sm-block" width={12} height={12} />{" "}
              </Tooltip>
            </div>
          </div>
        </div>
        <p className="m-0" style={{ color: theme["Colour ramps"].Green[300] }}>
          0% on Bebop
        </p>
      </div>
    </>
  );
};
